// 5-Punkt-Slider mit konfigurierbaren Labels
// value: 0..5 (0 = noch nicht gewählt; 1..5 = gewählt)
// onChange(v) wird mit 1..5 aufgerufen

import { useRef } from 'react'

export default function LikertSlider({ value = 0, onChange, labels }) {
  const wrapRef = useRef(null)

  // Wenn value=0 (noch keine Auswahl), Slider visuell in der Mitte zeigen, aber als „nicht gewählt"
  const displayValue = value || 3
  const hasValue = value > 0

  const setStep = (step) => onChange(Math.max(1, Math.min(5, step)))

  const onKeyDown = (e) => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
      e.preventDefault()
      setStep((value || 3) - 1)
    } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
      e.preventDefault()
      setStep((value || 3) + 1)
    } else if (e.key >= '1' && e.key <= '5') {
      e.preventDefault()
      setStep(Number(e.key))
    }
  }

  return (
    <div
      ref={wrapRef}
      className="space-y-3 outline-none"
      role="slider"
      aria-valuemin={1} aria-valuemax={5} aria-valuenow={hasValue ? displayValue : undefined}
      tabIndex={0}
      onKeyDown={onKeyDown}
    >
      <div className="relative pt-3 pb-2">
        {/* Track */}
        <div className="h-2 rounded-full bg-teal-100" />
        {/* Filled portion */}
        {hasValue && (
          <div
            className="absolute top-3 left-0 h-2 rounded-full bg-teal transition-all duration-300"
            style={{ width: `${((displayValue - 1) / 4) * 100}%` }}
          />
        )}
        {/* Step dots — sit on top of track, clicks always reach them */}
        <div className="absolute top-2.5 left-0 right-0 flex items-center justify-between">
          {[1, 2, 3, 4, 5].map(i => {
            const filled = hasValue && displayValue >= i
            const active = hasValue && displayValue === i
            return (
              <button
                key={i}
                type="button"
                onClick={() => setStep(i)}
                className={`w-3 h-3 rounded-full border-2 transition
                  ${filled ? 'bg-teal border-teal' : 'bg-white border-teal-300'}
                  ${active ? 'ring-2 ring-teal-300 ring-offset-1 scale-125' : ''}
                  hover:border-teal-500 cursor-pointer`}
                aria-label={`Wert ${i}`}
              />
            )
          })}
        </div>
      </div>
      <div className="grid grid-cols-5 gap-1 text-center">
        {labels.map((l, i) => {
          const active = hasValue && displayValue === i + 1
          return (
            <button
              key={i}
              type="button"
              onClick={() => setStep(i + 1)}
              className={`px-1 text-xs leading-snug transition cursor-pointer
                ${active ? 'text-teal-700 font-semibold' : 'text-ink-soft hover:text-ink'}`}
            >
              {l}
            </button>
          )
        })}
      </div>
    </div>
  )
}
